import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./Slices/AuthSlice";
import productSlice from "./Slices/ProductSlice";
const store = configureStore({
  reducer: {
    auth: authSlice,
    product: productSlice,
  },
});

export default store;
